import React from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { AccountDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}));

const Account = (props) => {
  const {className, match, history, ...rest} = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <AccountDetails history={history} />
        </Grid>
      </Grid>
    </div>
  );
};

export default withRouter(Account);
